import {
  CREATE_BERDIKARI_MART_SUCCESS,
  CREATE_BERDIKARI_MART_FAIL,
  RETRIEVE_BERDIKARI_MART_SUCCESS,
  RETRIEVE_BERDIKARI_MART_FAIL,
  UPDATE_BERDIKARI_MART_SUCCESS,
  UPDATE_BERDIKARI_MART_FAIL,
  DELETE_BERDIKARI_MART_SUCCESS,
  DELETE_BERDIKARI_MART_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_BERDIKARI_MART_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_BERDIKARI_MART_SUCCESS:
      return payload;

    case RETRIEVE_BERDIKARI_MART_FAIL:
      return [...datas];

    case UPDATE_BERDIKARI_MART_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_BERDIKARI_MART_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
